import React, { useEffect } from "react";
import { useApp } from "../../contexts/AppContext";

type Props = {
  children: React.ReactNode;
  blurBackground?: boolean;
};

function FullscreenMessage({ children, blurBackground = false }: Props) {
  const { setBlurBackground } = useApp();

  useEffect(() => {
    setBlurBackground(blurBackground);
  }, [blurBackground, setBlurBackground]);

  return (
    <div className="flex flex-1 flex-col justify-center p-4 items-center text-xl bg-gradient bg-blue relative">
      {children}
    </div>
  );
}

export default FullscreenMessage;
